import * as React from 'react';
import { colors } from '../../../index';

const IconUpload = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 17 11",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 4.15C12.526.262 7.833-1.33 4.853 1.285A5.135 5.135 0 003.68 2.78C.524 3.091-1.112 6.702.735 9.28A4.12 4.12 0 004.12 11h8.94c2.637.092 4.384-2.704 3.146-5.034A3.427 3.427 0 0013.3 4.15zM9.62 6.2v2.75H6.88V6.19H4.8l3.44-3.44 3.44 3.44H9.63z"
  }));
};

export default IconUpload;